import apiClient, { toApiError } from "../client";
import {
  LoginCredentials,
  SignupCredentials,
  AuthResponse,
  User,
} from "@/types/user.types";
import { ApiResponse } from "@/types/api.types";

export const authApi = {
  // Register (backend uses /register not /signup)
  register: async (credentials: SignupCredentials): Promise<AuthResponse> => {
    try {
      const response = await apiClient.post<ApiResponse<AuthResponse>>(
        "/auth/register",
        credentials,
      );
      return response.data.data;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Login
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    try {
      const response = await apiClient.post<ApiResponse<AuthResponse>>(
        "/auth/login",
        credentials,
      );
      return response.data.data;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Get current user profile
  getCurrentUser: async (): Promise<User> => {
    try {
      const response =
        await apiClient.get<ApiResponse<{ user: User }>>("/auth/me");
      return response.data.data?.user;
    } catch (error) {
      throw toApiError(error);
    }
  },

  loginWithGoogle: async (token: string): Promise<AuthResponse> => {
    try {
      const response = await apiClient.post<ApiResponse<AuthResponse>>(
        "/auth/google",
        { token },
      );
      return response.data.data;
    } catch (error) {
      throw toApiError(error);
    }
  },

  // Logout (clear local tokens - backend may not have logout endpoint)
  logout: async (): Promise<void> => {
    // Just clear local storage, no API call needed
    localStorage.removeItem("token");
  },

  // Note: Backend doesn't have separate refresh token endpoint
  // Token refresh would be handled by the API client interceptor if needed
};
